import React from 'react'
import Select from 'react-select'

type Bank = {
  index: number
  code: string
  name: string
  swift: string
}

type CountryConfig = {
  LengthRIB?: number | { min: number; max: number }
  LengthCIN?: number
  lengthPhone: number
  lengthCodeIBAN?: number
  CodeIBAN?: string
  banks?: Bank[]
}
interface Props {
  formik: any
  prefixSelected: string
  detailsPays: CountryConfig
}

const BeneficiaryPersonalInfo: React.FC<Props> = ({ formik, prefixSelected, detailsPays }) => {
  const maxLengthRIB = typeof detailsPays.LengthRIB === 'number' ? detailsPays.LengthRIB : detailsPays.LengthRIB?.max
  const isTurkeyOrPhilippines = prefixSelected === '90' || prefixSelected === '63'
  console.log('tttt', isTurkeyOrPhilippines, formik.values)
  return (
    <div className="flex flex-col items-center gap-3 mt-3">
      {prefixSelected !== '216' && (
        <div className="w-full">
          <label className="h3">
            CIN du bénéficiaire <span className="text-[#EE443F]">*</span>
          </label>

          <input
            className={` placeholder:text-[#D1D1FF] rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
            name="beneficiaryIdentifiant"
            placeholder="CIN du bénéficiaire"
            value={formik.values.beneficiaryIdentifiant}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={detailsPays.LengthCIN}
            onKeyDown={(e) => {
              if (
                prefixSelected !== '212' &&
                !/[0-9]/.test(e.key) &&
                !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
              ) {
                e.preventDefault()
              }
            }}
          />

          <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px]">
            {formik.touched.beneficiaryIdentifiant && formik.errors.beneficiaryIdentifiant}
          </p>
        </div>
      )}

      {(isTurkeyOrPhilippines) && (
        <div className="flex flex-col w-full">
          <label className="h3">
            Sélectionnez votre banque <span className="text-[#EE443F]">*</span>
          </label>

          <Select
            classNamePrefix="select"
            isSearchable={false}
            placeholder="Sélectionnez votre banque"
            options={detailsPays.banks}
            value={detailsPays.banks?.find((bank: Bank) => bank.name === formik.values.bankName) || null}
            onChange={(option) => {
              formik.setFieldValue('bankName', option?.name || '')
              formik.setFieldValue('SWIFTBIC', option?.swift|| '')
              formik.setFieldValue('bankCode', option?.code|| '')            }
            }
            onBlur={() => formik.setFieldTouched('bankName', true)}
            getOptionValue={(option) => option.name}
            getOptionLabel={(option) => option.name}
          //   menuPortalTarget={document.body}
          //    styles={{
          //   menu: (base) => ({
          //     ...base,
          //     zIndex: 10,
          //   }),
          // }}
          />

          <p className="text-[#EE443F] text-[10px] mt-1 h-[15px]">
            {formik.touched.bankName && formik.errors.bankName}
          </p>
        </div>
      )}

      <div className="w-full">
        <label className="h3">
          {isTurkeyOrPhilippines ? 'Numéro IBAN' : 'RIB'}{' '}
          <span className="text-[#EE443F]">*</span>
        </label>
        {prefixSelected === '216' && (
          <div className="text-[#422EAE] text-[12px] sm:text-[12px] my-1">
            (Seuls les comptes en dinars tunisiens (TND) sont acceptés)
          </div>
        )}

        <div className={` flex items-center rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`} >
          {formik.values.CodeIBAN && (
            <div className="text-[#422EAE] font-bold font-roboto pr-[10px]">{formik.values.CodeIBAN}</div>
          )}
          <input
            className="outline-none w-full placeholder:text-[#D1D1FF]"
            name="Iban"
            placeholder={
              prefixSelected === '90' || prefixSelected === '63' ? 'Numéro IBAN' : 'Numéro de compte bancaire'
            }
            value={formik.values.Iban}
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={maxLengthRIB}
          />
        </div>
        <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px]">
          {formik.touched.Iban && formik.errors.Iban}
        </p>
      </div>
      <div className="w-full">
        <label className="h3">
          {isTurkeyOrPhilippines
            ? 'Confirmez le numéro IBAN'
            : 'Confirmez le numéro de compte'}{' '}
          <span className="text-[#EE443F]">*</span>
        </label>

        <div
          className={`  flex items-center rounded-[16px] border border-[#AEB6FB] focus:border-[#5754E5] h-[56px] sm:h-[40px] text-[#5754E5] text-[16px] px-[10px] w-full outline-none`}
        >
          {formik.values.CodeIBAN && (
            <div className="text-[#422EAE] font-bold font-roboto pr-[10px]">{formik.values.CodeIBAN}</div>
          )}

          <input
            className="outline-none w-full placeholder:text-[#D1D1FF]"
            name="confirmerNumeroCompte"
            placeholder={
              isTurkeyOrPhilippines
                ? 'Confirmez le numéro IBAN'
                : 'Confirmez le numéro de compte bancaire'
            }
            value={formik.values.confirmerNumeroCompte}
            type="text"
            onChange={formik.handleChange}
            maxLength={maxLengthRIB}
            onBlur={formik.handleBlur}
          />
        </div>

        <p className="text-[#EE443F] w-full text-[10px] mt-1 h-[15px]">
          {formik.touched.confirmerNumeroCompte && formik.errors.confirmerNumeroCompte}
        </p>
      </div>
    </div>
  )
}

export default BeneficiaryPersonalInfo
